export default __webpack_public_path__ + "static/media/ru-store-black.c80c4427.svg";